if (window.pageYOffset > 35) {
    if (document.getElementById("header")) {
        document.getElementById("header").classList.add("header-fixed")
    }
} else {
    if (document.getElementById("header")) {
        document.getElementById("header").classList.remove("header-fixed")
    }
}

window.addEventListener("scroll", event => {
    if (window.pageYOffset > 450) {
        if (document.getElementById("header")) {
            document.getElementById("header").classList.add("header-fixed")
        }
    } else {
        if (document.getElementById("header")) {
            document.getElementById("header").classList.remove("header-fixed")
        }
    }
});

function setShowContact(bool) {
    if (bool) {
        document.body.classList.add("disable__scroll");
        document.getElementById("productPopup").classList.remove("display-not");
    } else {
        document.body.classList.remove("disable__scroll");
        document.getElementById("productPopup").classList.add("display-not");
    }
}

function setShowFerie(bool) {
    if (bool) {
        document.body.classList.add("disable__scroll");
        document.getElementById("feriePopup").classList.remove("display-not");
    } else {
        document.body.classList.remove("disable__scroll");
        document.getElementById("feriePopup").classList.add("display-not");
        sessionStorage.setItem("kaiserPopup", "afvist")
    }
}

if (!sessionStorage.getItem("kaiserPopup")) {
    if (document.getElementById("feriePopup")) {
        document.getElementById("feriePopup").classList.remove("display-not");
    }
}

function openPhoneMenu() {
    document.getElementById("phone__header").classList.add("header__visible");
    document.body.classList.add("disable__scroll");
}

function closePhoneMenu() {
    document.getElementById("phone__header").classList.remove("header__visible");
    document.body.classList.remove("disable__scroll");
}